import React from 'react';
import { IconUiSuccess } from '@uberall/zenit';
import classnames from 'classnames';

import styles from './step.module.css';
import Message from '../Message';

type StepProps = {
    step: number;
    label: string;
    currentStep: number;
};

const Step = ({ step, label, currentStep }: StepProps) => (
    <li className={styles.listItem}>
        <div
            className={classnames(styles.counter, {
                [styles.counterOutlined]: step > currentStep,
            })}
        >
            {step < currentStep ? (
                <IconUiSuccess aria-label={`Step ${step} is done`} />
            ) : (
                <span>{step}</span>
            )}
        </div>
        {step === currentStep && <Message className={styles.label} code={label} />}
    </li>
);

export default Step;
